import React from 'react';
import PropTypes from 'prop-types';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { SummaryBarContainer } from '@bingads-webui-react/summary-bar';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { SimpleBreadcrumb } from './components/simple-breadcrumb';

class AccountsSummaryBarInternal extends React.PureComponent {
  render() {
    const {
      i18n,
      selectedParent,
      breadCrumbText,
      permissions,
    } = this.props;

    return (
      <SummaryBarContainer
        texts={{
          ariaLabel: i18n.getString(_TL_('Summary bar')),
        }}
        breadcrumb={<SimpleBreadcrumb
          selectedItem={selectedParent}
          maxDisplayedItems={2}
          breadCrumbText={breadCrumbText}
          i18n={i18n}
        />}
        showScopeBackButton={isNavigationRefreshOn(permissions)}
        i18n={i18n}
      />
    );
  }
}

AccountsSummaryBarInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  selectedParent: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  breadCrumbText: PropTypes.string,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

AccountsSummaryBarInternal.defaultProps = {
  breadCrumbText: null,
  selectedParent: null,
};

export const AccountsSummaryBar = withPermissions(withI18nConsumer(AccountsSummaryBarInternal));

